import { useEffect } from "preact/hooks";
import { EventType } from "./../enums/event-type";

function usePostMessage(sender: string, action: EventType, data: any, callback?: () => void) {
  useEffect(() => {
    const message = { sender, action, data };

    window?.parent?.postMessage(message, "*");
  }, [callback, sender, action, data]);
}

export default usePostMessage;
